import { readable } from 'svelte/store';
import Papa from 'papaparse';
	
	//data: "2020-03-21 17:00:00"
	//stato: "ITA"
	//codice_regione: "05"
	//denominazione_regione: "Veneto"
	//lat: "45.43490485"
	//long: "12.33845213"
	//ricoverati_con_sintomi: "942"
	//terapia_intensiva: "249"
	//totale_ospedalizzati: "1191"
	//isolamento_domiciliare: "3023"
	//totale_attualmente_positivi: "4214"
	//nuovi_attualmente_positivi: "537"
	//dimessi_guariti: "257"
	//deceduti: "146"
	//totale_casi: "4617"
	//tamponi: "53642"
		
export const dataNazionale = readable(Array.from([]), function start(set) {
	console.log("[data.store][start]");
		Papa.parse("https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-andamento-nazionale/dpc-covid19-ita-andamento-nazionale.csv", {
				download: true,
				header: true,
				skipEmptyLines: true,
				complete: function(results) {
					console.log("data parsed : ", results)
					set(Array.from(results.data));
				}
		});	

		return function stop() {
			console.log("[data.store][stop]");
		};
});